import React from "react";

export const SearchToolContext = React.createContext({});
